module.exports = __webpack_public_path__ + "img/amx-7.cb731b15.jpg";